export const actionTypes = {
    ANSWER_QUESTION: 'tableQrcode/ANSWER_QUESTION',
}

export const answerQuestion = payload => ({
    type: actionTypes.ANSWER_QUESTION,
    payload,
})